import React, { useEffect } from 'react';
import { CODEBUILD_BUILD_NUMBER, LOG_ROCKET_APP_ID } from "api-config";
import { isBrowser } from './Browser';
import LogRocket from 'logrocket';
import { useSessionContext } from "./Session";
import log from 'loglevel';


// LogRocket records every request with its headers unless told otherwise. `x-auth-token`
// on POST /a2/login is the credential itself, and for the password sign-in
// (newSessionWithPassword in api.mjs) that is base64 of the email and password, so it is
// blanked before a request is recorded. `network.requestSanitizer` is LogRocket's hook
// for this (https://docs.logrocket.com/reference/network).
//
// LogRocket is switched off today (ENABLE_LOG_ROCKET in api-config.mjs). This is here so
// that switching it back on does not start recording passwords.
export const withoutAuthToken = (request) => {
  Object.keys(request?.headers || {}).forEach((name) => {
    if (name.toLowerCase() === "x-auth-token") {
      request.headers[name] = "";
    }
  });
  return request;
};

const LogRocketWrapper = () => {
  const { sessionContext } = useSessionContext();
  log.debug(`LogRocketWrapper: sessionContext`, sessionContext);
  const { isAdminUser, session } = sessionContext || {};
  const { user } = session || {};
  log.debug(`LogRocketWrapper: user`, user);
  const { email, name } = user || {};

  useEffect(() => {
    if (isBrowser()) {
      log.info(`LogRocket::init() ${LOG_ROCKET_APP_ID} ${CODEBUILD_BUILD_NUMBER}`);
      LogRocket.init(LOG_ROCKET_APP_ID, {
        release: CODEBUILD_BUILD_NUMBER,
        serverURL: `${window.location.origin}/i`,
        network: { requestSanitizer: withoutAuthToken },
      });
    } else {
      log.info("not initializing LogRocket due to no browser detected.");
    }
  }, []);

  useEffect(() => {
    if (isBrowser()) {
      const traits = {
        email,
        name,
        isAdminUser,
      };
      log.info(`LogRocket.identify(${email}) traits:`, traits);
      LogRocket.identify(email, traits);
    } else {
      log.info("not calling LogRocket.identify due to no browser detected.");
    }
  }, [email, name, isAdminUser]);

  return (<></>);
};

export {
  LogRocketWrapper
};
